import { PushNotificationsService } from './push-notification/push-notification-service';
import { Component, OnInit, Inject, AfterViewInit, OnDestroy, HostListener, Directive } from '@angular/core';
import { HttpRequest, HttpEventType, HttpClient } from '@angular/common/http';
import { Router, Event, NavigationEnd, ActivatedRoute } from '@angular/router';
import * as _ from 'underscore';
import { HeaderService } from './components/header/header.service';
import { LoaderComponent } from './loader/loader.component';
import { SocketService } from './socket/socket.service';
import { SettingsService } from './components/settings/settings.service';
import { AlertPopup, BASE_URI } from './app.config';
import { DataSharingService } from './shared/data-sharing.service';

import { UserService } from './components/userandgroup/user/user.service';
import { GuidedTour, GuidedTourService, Orientation, ProgressIndicatorLocation } from 'ngx-guided-tour';
import { DOCUMENT } from '@angular/common';
import { ThemeService } from './components/settings/theme.service';
import { LoginService } from './components/login/login.service';
import { AssistBotService } from './components/ai-assist/assist-bot.service';
import { LlmService } from './services/llm.service';
import { IndexedDBService } from './services/indexed-db.service';
// @Directive()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class AppComponent implements OnInit, OnDestroy {
  // @HostListener('window:focus', ['$event'])
  // @HostListener('window:blur', ['$event'])
  title = 'app';
  isWindowFocused = true;
  public userLoggin = false;
  public userSetting: any = {};
  public callingUserDetails: any = {}
  public menuListItem: any;
  public userDetail: any;
  public userStatus = [];
  public selectedFilesList: any[] = [];
  is_tour_completed = false;
  public activated: {
    loginPage: boolean;
  };
  activeUserRole: any = "";
  public currentToken;

  subscribers: any = {
    isSubscribed: false
  };
  actualUrl: any;
  activeUrl: any;
  companyid: string;
  progressIndicatorLocation: any;
  showproductlogo: boolean = true;
  TOUR: GuidedTour;
  constructor(
    private http: HttpClient,
    private socketService: SocketService,
    private headerService: HeaderService,
    private settingsService: SettingsService,
    private route: ActivatedRoute,
    private router: Router,
    private dataSharingService: DataSharingService,
    @Inject(DOCUMENT) private document: Document,
    private userService: UserService,
    private _notificationService: PushNotificationsService,
    private alert: AlertPopup,
    private guidedTourService: GuidedTourService,
    private themeService: ThemeService,
    private loginService: LoginService,
    private assistBotService: AssistBotService, private llmService: LlmService,
    private indexedDBService: IndexedDBService
  ) {

    this._notificationService.requestPermission();
    this.progressIndicatorLocation = ProgressIndicatorLocation.TopOfTourBlock;
    this.activated = {
      loginPage: false
    };


    this.router.events.subscribe(
      (event: Event): void => {
        if (event instanceof NavigationEnd) {
          this.activeUrl = this.router.url.split('/')[1];
          this.actualUrl = this.router.url.split('/')[2];

          if (['login', 'reset_password', 'sign_up', 'password_reset', 'verify_otp'].includes(this.activeUrl)) {
            this.activated.loginPage = true;
          } else {
            this.activated.loginPage = false;
          }
        }
      },
      error => {
        console.log(error);
      });


    // this.hintService.overlay$.subscribe(data => {
    //   if (!data) {
    //     this.updateUserOnboarding();
    //   }
    // });


  }

  onResize(event) {
    event.target.innerWidth; // window width
  }


  dragOverHandler = (e) => {
    e.preventDefault();
  }

  dropHandler = (e) => {
    e.preventDefault();
  }

  focusHandler = (e) => {
    e.preventDefault();
    this.isWindowFocused = true;
  };

  focusBlurHandler = (e) => {
    this.isWindowFocused = false;
  };



  ngOnInit(): void {

    this.themeService.setTheme('steelblue');

    const myTheme = localStorage.getItem("myTheme");
    // if (myTheme) this.themeService.setTheme(myTheme);

    this.document.body.classList.add('scroll-stop');

    window.addEventListener('dragover', this.dragOverHandler);
    window.addEventListener('drop', this.dropHandler);
    window.addEventListener('focus', this.focusHandler);
    window.addEventListener('blur', this.focusBlurHandler);

    this.currentToken = localStorage.getItem('token');

    const role = localStorage.getItem('user_role');

    if (role) {
      this.activeUserRole = parseInt(role, 10);
    }

    if (this.currentToken) {

      this.getUserStatusData();
      this.getCurrentUserData();

    } else {

      localStorage.clear();

    }
    setTimeout(() => {
      this.showproductlogo = false;
    }, 2000);
  }

  emitReadUpdate(response) {
    let updateDelivery = {};
    updateDelivery = _.pick(response, 'message_id', 'chat_type', 'from_user_id', 'to_user_id');
    this.socketService.updateReadMessage(updateDelivery);
  };

  observableRefresh() {

    try {

      if (window.localStorage.token) {
        if (this.subscribers.isSubscribed) {
          return;
        } else {
          this.subscribers.isSubscribed = true;
        }

        this.subscribers.userMessage = this.socketService.receiveNewUserMessage().subscribe(newMessage => {
          console.log("receiveNewUserMessage", newMessage);
          const response = {
            message: newMessage,
            settings: this.userSetting
          };
          this.dataSharingService.emitNewUserMessage(response);
          if (this.activeUrl === 'chats' && this.actualUrl === 'singleuser') {
            const paramId = +this.router.url.split('/')[3];
            if ((newMessage && newMessage.from_user_id) === paramId && this.isWindowFocused) {
              this.emitReadUpdate(newMessage);
            } else {
              this.emitUpdateDelivery(newMessage);
              if (this.userSetting.enable_desktop_alert) {
                if (this.userSetting.user_msg_alert) {
                  this._notificationService.generateNotification(newMessage);
                }
              }
            }
          } else {
            this.emitUpdateDelivery(newMessage);
            if (this.userSetting.enable_desktop_alert) {
              if (this.userSetting.user_msg_alert) {
                this._notificationService.generateNotification(newMessage);
              }
            }
          }

          if (this.activeUrl !== 'chats') {
            this.dataSharingService.emitNotifyCount({ menu: 'chats', count: 0 });
          }

        });

        this.subscribers.groupMessage = this.socketService.receiveNewGroupMessage().subscribe(newMessage => {
          console.log("receiveNewGroupMessage", newMessage);
          const response = {
            message: newMessage,
            settings: this.userSetting
          };
          this.dataSharingService.emitNewGroupMessage(response);
          this.emitUpdateDelivery(newMessage);

          if (this.activeUrl === 'chats' && this.actualUrl === 'groupuser') {
            const paramId = +this.router.url.split('/')[3];
            if ((newMessage && newMessage.group_id) !== paramId) {
              if (this.userSetting.enable_desktop_alert) {
                if (this.userSetting.group_msg_alert) {
                  this._notificationService.generateNotification(newMessage);
                }
              }
            }
          }

          if (this.activeUrl !== 'chats') {
            // this.dataSharingService.emitNotifyCount('chats');
            this.dataSharingService.emitNotifyCount({ menu: 'chats', count: 0 });
            if (this.userSetting.enable_desktop_alert) {
              if (this.userSetting.group_msg_alert && newMessage.group_id) {
                this._notificationService.generateNotification(newMessage);
              }
            }
          }

        });

        this.subscribers.meetingSessions = this.socketService.meetingCallingSession().subscribe(session => {
          if (session !== null && session !== undefined) {
            this.callingUserDetails = session
            this.callingUserDetails['type'] = true
          }
        })

        this.subscribers.callAccepted = this.socketService.callAccepted().subscribe(response => {
          this.dataSharingService.emitCallAccepted(response)
        })
        // ice candidate
        this.subscribers.iceCandidate = this.socketService.icecandidate().subscribe(ice => {
          this.dataSharingService.emitIceCandidate(ice)
        })

        this.subscribers.sdp = this.socketService.sdpSession().subscribe(sdp => {
          this.dataSharingService.emitSdp(sdp)
        })


        // this.subscribers.staff_topic = this.socketService.studyRoomSession().subscribe(public_topic => {
        //   // this.dataSharingService.emitSdp(staff_topic)
        //   this.dataSharingService.emitPublishTopic(public_topic);
        //   console.log(public_topic);

        // })


        this.subscribers.userStatusNotify = this.socketService.receiveUserStatus().subscribe(response => {
          console.log("receiveUserStatus", response);
          this.dataSharingService.emitUserStatusNotify(response);
        });


        this.subscribers.userTypingUpdate = this.socketService.receiveUserTypingStatus().subscribe(typingStatusData => {
          console.log("receiveUserTypingStatus", typingStatusData);
          this.dataSharingService.emitTypingStatusNotify(typingStatusData);
        });


        this.subscribers.initiateNewChat = this.socketService.receiveNewChat().subscribe(userChat => {
          console.log("receiveNewChat", userChat);
          this.dataSharingService.emitNewChatsNotify(userChat);
        });

        this.subscribers.receiveUserStatusUpdate = this.socketService.receiveUserStatusUpdate().subscribe(userStatus => {
          console.log('receiveUserStatusUpdate', userStatus);
          this.dataSharingService.emituserStatusUpdate(userStatus);
        });


        this.subscribers.updateDelivery = this.socketService.updateDeliveredResponse().subscribe(deliveredMessage => {
          this.dataSharingService.emitMessageUpdateNotify(deliveredMessage);
        });

        this.subscribers.readBulkMessage = this.socketService.readMessageOnTab().subscribe(readedMessage => {
          this.dataSharingService.emitBulkReadMsgUpdateNotify(readedMessage);
        });


        this.subscribers.groupUpdate = this.socketService.receiveUpdateChatGroup().subscribe(updatedGroup => {
          this.dataSharingService.emitGroupUpdateNotify(updatedGroup);
        });

      }
    } catch (e) {
      console.log(e);
    }
  }



  emitUpdateDelivery(response) {
    let updateDelivery = {};
    updateDelivery = _.pick(response, 'message_id', 'chat_type', 'from_user_id', 'to_user_id');
    this.socketService.updateDeliveredMessage(updateDelivery);
  };


  getCurrentUserData(): void {

    this.headerService.getCurrentUserDetail().subscribe({
      next: (user: any) => {

        const userDetail = user?.userDetail;
        const companyDetail = user?.company_details;

        if (!userDetail) return;

        this.companyid = userDetail.company_id;

        localStorage.setItem('username', userDetail.first_name);

        const llmToken = localStorage.getItem("llm_token");

        if (!llmToken) {
          this.llmService
            .llmUserLogin({
              client_id: userDetail.company_id,
              user_id: userDetail.user_id
            })
            .subscribe((llmresponse: any) => {
              if (llmresponse?.token) {
                localStorage.setItem("llm_token", llmresponse.token);
                this.llmService.LLM_classes = llmresponse.class_access;
              }
            });
        }

        if (companyDetail) {

          const company = {
            company_logo: companyDetail.company_logo,
            title: companyDetail.title,
            caption: companyDetail.caption
          };

          this.userDetail = { ...company, ...userDetail };

        } else {
          this.userDetail = userDetail;
        }

        this.is_tour_completed = !this.userDetail?.is_tour_completed;

        this.userSetting = user?.settingsDetail;

        this.menuListItem = user?.menuList?.map((menu: any) => ({
          ...menu,
          path: `main/${menu.menu_name}`
        }));

        this.socketService.initiateSocket();

        this.observableRefresh();

        this.activated.loginPage = false;

        if (
          ['login', 'reset_password', 'sign_up', 'password_reset', 'verify_otp']
            .includes(this.activeUrl)
        ) {
          this.router.navigate(["elibraryandcourse/e-library"]);
        } else {
          this.router.navigate([this.activeUrl]);
        }

        console.log(this.is_tour_completed, 'get tour completed or not');



        if (this.is_tour_completed) {
          this.startTour();
        }
      },

      error: (error) => {

        const isLogout = error?.error?.logout;

        if (isLogout) {
          this.router.navigate(['/login']);
        }

      }
    });
  }

  getUserStatusData() {

    this.headerService.getUserStatus().subscribe((res: any) => {
      this.userStatus = res;

      // this.loginstatus();
    })
  }

  doBeforeUnload() {
    // Alert the user window is closing
    return false;
  }

  loginstatus() {
    // const payload = {
    //   user_id: this.userDetail.user_id,
    //   status_id: 1
    // }

    // this.headerService.updateStatus(payload).subscribe((res: any) => {

    //   const copyUserDetail = {...this.userDetail}
    //   copyUserDetail.status_name = res.response.status_name;
    //   copyUserDetail.user_status = res.response.status_id;
    //   this.userDetail = copyUserDetail;
    // });
  }

  onFocus(event: FocusEvent): void {

    // Do something
    const payload = {
      user_id: this.userDetail.user_id,
      status_id: 0
    }

    this.headerService.updateStatus(payload).subscribe(res => {
      window.localStorage.clear();
    });

  }
  onBlur(event: FocusEvent): void {
    // Do something
    const payload = {
      user_id: this.userDetail.user_id,
      status_id: 0
    }

    this.headerService.updateStatus(payload).subscribe(res => {
      window.localStorage.clear();
    });

  }

  doUnload() {
    const payload = {
      user_id: this.userDetail.user_id,
      status_id: 0
    }

    this.headerService.updateStatus(payload).subscribe(res => {
      window.localStorage.clear();
    });
  }

  socketTyping(payLoad) {
    try {
      if (this.socketService) {
        this.socketService.emitUserTypingStatus(payLoad);
      }
    } catch (err) {
      console.log(err);
    }
  };



  updateUserOnboarding() {
    this.userService.updateUserOnboarding().subscribe(response => {
      this.userDetail.is_tour_completed = true;
    }, error => {

    })
  };

  fileUploadWithProgess(formFields, filesList) {
    return new Promise((resolve, reject) => {
      const URL = `${BASE_URI.URL}/uploadFiles`;
      if (filesList && filesList.length > 0) {
        const promise: any[] = [];
        filesList.map(el => {
          promise.push(this.sendFileToServer(el, filesList, formFields).then(fileResp => {
            return fileResp;
          },
            error => {
              reject(error)
            }))
        });

        Promise.all(promise).then(allFileResponse => resolve(allFileResponse)).catch(err => reject(err));
      }
    })
  };


  sendFileToServer(file, filesList, formFields) {
    return new Promise((resolve, reject) => {
      const URL = `${BASE_URI.URL}/uploadFiles`;
      const formData: FormData = new FormData();
      formData.append(formFields.fieldName, file);
      formData.append('uniq', `${Date.now()}`);
      for (const key in formFields) {
        if (key) {
          formData.append(key, formFields[key]);
        }
      }

      const req = new HttpRequest('POST', URL, formData, { reportProgress: true });
      this.http.request(req).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          file.progressVal = Math.round(100 * event.loaded / event.total);
        }

        if (event.type === HttpEventType.Response) {
          const index = filesList.indexOf(file);
          filesList.splice(index, 1);
          resolve(event['body']);
        }
      },
        error => {
          reject(error);
        });
    });
  };

  //number validation
  commonValidateNumber(evt: any, labelName) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      this.alert.showAlertMessage({ message: 'Please enter number value only' })
      return false;
    }

    return true;
  }


  startTour(): void {

    const commonSteps = [
      {
        title: "AI Assistance",
        selector: "#menu_item_1",
        content: "This tool provides information based on your queries.",
        orientation: Orientation.Right
      },
      {
        title: "Documents",
        selector: "#menu_item_3",
        content: "Admins can upload documents and share them with users. Users can view documents and take notes.",
        orientation: Orientation.Right
      }
    ];

    if (this.activeUserRole === 1) {

      this.TOUR = {
        tourId: "Tour",
        useOrb: false,
        skipCallback: () => console.log("Skip clicked"),
        completeCallback: () => {
          this.updateUserOnboarding();
          console.log("Complete clicked");
        },
        steps: [
          ...commonSteps,
          {
            title: "Manage Users",
            selector: "#menu_item_4",
            content: "Create new users, manage registered users, and organize active users.",
            orientation: Orientation.Right
          },
          {
            title: "Discussion",
            selector: "#menu_item_5",
            content: "Chat with your team or invited members through one-to-one or group conversations.",
            orientation: Orientation.Right
          },
          {
            title: "Notifications",
            selector: "#menu_item_6",
            content: "Stay updated with important alerts, messages, and system notifications.",
            orientation: Orientation.Right
          },
          {
            title: "Create New User",
            selector: "#createStudent",
            content: "Use this button to add a new user. You can select users from the list to assign lessons.",
            orientation: Orientation.Bottom
          },
          {
            title: "Settings",
            selector: "#menu_item_7",
            content: "Configure your application settings here.",
            orientation: Orientation.Right
          },
          {
            title: "Interactive Videos",
            selector: "#menu_item_10",
            content: "Watch and learn through interactive video content.",
            orientation: Orientation.Right
          },
          {
            title: "Summarization",
            selector: "#menu_item_11",
            content: "Summarize your uploaded documents quickly.",
            orientation: Orientation.Right
          },
          {
            title: "Feedback",
            selector: "#menu_item_12",
            content: "Share your feedback with us here.",
            orientation: Orientation.Right
          },
          {
            title: "Excel Q&A",
            selector: "#menu_item_14",
            content: "Ask questions and analyze your Excel data here.",
            orientation: Orientation.Right
          },
          {
            title: "Manage Clients",
            selector: "#menu_item_15",
            content: "Add and manage client information here.",
            orientation: Orientation.Right
          }
        ]
      };

    } else if (this.activeUserRole === 2) {

      this.TOUR = {
        tourId: "Tour",
        useOrb: false,
        skipCallback: () => console.log("Skip clicked"),
        completeCallback: () => {
          this.updateUserOnboarding();
          console.log("Complete clicked");
        },
        steps: [
          ...commonSteps,
          {
            title: "Manage Users",
            selector: "#menu_item_4",
            content: "Create and manage users within the system.",
            orientation: Orientation.Right
          },
          {
            title: "Notifications",
            selector: "#menu_item_6",
            content: "Stay updated with important alerts and messages.",
            orientation: Orientation.Right
          },
          {
            title: "Create New User",
            selector: "#createStudent",
            content: "Use this button to add a new user.",
            orientation: Orientation.Bottom
          },
          {
            title: "Settings",
            selector: "#menu_item_7",
            content: "Configure your application settings here.",
            orientation: Orientation.Right
          },
          {
            title: "Interactive Videos",
            selector: "#menu_item_10",
            content: "Watch and learn through interactive video content.",
            orientation: Orientation.Right
          },
          {
            title: "Summarization",
            selector: "#menu_item_11",
            content: "Summarize your uploaded documents quickly.",
            orientation: Orientation.Right
          },
          {
            title: "Excel Q&A",
            selector: "#menu_item_14",
            content: "Ask questions and analyze your Excel data here.",
            orientation: Orientation.Right
          }
        ]
      };

    } else {

      this.TOUR = {
        tourId: "purchases-tour",
        useOrb: false,
        skipCallback: () => console.log("Skip clicked"),
        completeCallback: () => {
          this.updateUserOnboarding();
          console.log("Complete clicked");
        },
        steps: [
          ...commonSteps,
          {
            title: "Notifications",
            selector: "#menu_item_6",
            content: "Stay updated with important alerts and messages.",
            orientation: Orientation.Right
          },
          {
            title: "Settings",
            selector: "#menu_item_7",
            content: "Configure your application settings here.",
            orientation: Orientation.Right
          },
          {
            title: "Interactive Videos",
            selector: "#menu_item_10",
            content: "Watch and learn through interactive video content.",
            orientation: Orientation.Right
          },
          {
            title: "Summarization",
            selector: "#menu_item_11",
            content: "Summarize your uploaded documents quickly.",
            orientation: Orientation.Right
          },
          {
            title: "Excel Q&A",
            selector: "#menu_item_13",
            content: "Ask questions and analyze your Excel data here.",
            orientation: Orientation.Right
          }
        ]
      };

    }

    this.guidedTourService.startTour(this.TOUR);
  }

  toggleSideMenu() {
    // let sidebar = this.document.querySelector('.sidebar');
    //    sidebar.classList.toggle('collapse-menu');
    this.userSetting.visible_sidebar = !this.userSetting.visible_sidebar;
  }

  ngAfterViewInit() {
    this.indexedDBService.initDB();
  }

  ngOnDestroy(): void {

    this.subscribers.isSubscribed = false;

    this.subscribers?.userMessage?.unsubscribe();
    this.subscribers?.groupMessage?.unsubscribe();
    this.subscribers?.userStatusNotify?.unsubscribe();
    this.subscribers?.userTypingUpdate?.unsubscribe();
    this.subscribers?.initiateNewChat?.unsubscribe();
    this.subscribers?.updateDelivery?.unsubscribe();
    this.subscribers?.readBulkMessage?.unsubscribe();
    this.subscribers?.groupUpdate?.unsubscribe();
    this.subscribers?.receiveUserStatusUpdate?.unsubscribe();

    window.removeEventListener('dragover', this.dragOverHandler);
    window.removeEventListener('drop', this.dropHandler);
    window.removeEventListener('focus', this.focusHandler);
    window.removeEventListener('blur', this.focusBlurHandler);

  }

}
